import { LogicalFieldMixin, RangeLogicalFieldMixin } from './mixins.js';

const LogicalInteger = {
  mixins: [
    LogicalFieldMixin,
    RangeLogicalFieldMixin
  ],

  template: `
    <div class="form-field-input">
      <input type="number" readonly placeholder='请输入' />
      <div class="options logic-options">
        <range-logic-option v-for='option in logicSettings'
                            :editing='editing'
                            :logic='option'
                            :controlableFields='controlableFields'
                            :possibleFields='possibleFields'
                            :logicable='logicable'
                            ref='rangeOptions'
                            @childAdded='addChildFunc'
                            @editingChanged='changeEditingStatus'
                            @removeLogic='removeLogic'
                            @updateSetting='updateLogicSetting' />
      </div>
      <div class="field-input-footer">
        <button class="text-btn" v-show='editing' @click='addLogic'>添加逻辑</button>
      </div>
    </div>
  `
};

export default LogicalInteger;
